import { api } from './api';

/**
 * Déclenche la transition SSO vers l'application Camp (Bala-Camp).
 *
 * Échange la session Staff contre un jeton éphémère à usage unique auprès
 * de `services/api`, puis redirige vers l'URL SSO de Camp avec le parcours cible.
 */
export async function openCampSso(target?: string, openInNewTab = false): Promise<void> {
  try {
    const res = await api.post<{ url: string }>('/auth/camp-sso', { target: target || '' });
    if (res?.url) {
      if (openInNewTab) {
        window.open(res.url, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = res.url;
      }
      return;
    }
  } catch (error) {
    console.error('Erreur lors de la génération du lien SSO Camp:', error);
  }

  // Repli : ouverture de l'application Camp (l'utilisateur pourra se connecter manuellement si besoin)
  const fallbackBase = import.meta.env.VITE_CAMP_URL || (import.meta.env.PROD ? 'https://camp.baladins11.be' : 'http://localhost:5174');
  const fallbackUrl = target ? `${fallbackBase}${target}` : fallbackBase;
  if (openInNewTab) {
    window.open(fallbackUrl, '_blank', 'noopener,noreferrer');
  } else {
    window.location.href = fallbackUrl;
  }
}
